import { Injectable } from '@angular/core';
import { StorageVariable } from '../object/local-storage-variable.enum';

@Injectable()
export class SecurityService {
    //token
    setToken(token: string) {
        sessionStorage.setItem(StorageVariable.ACCESS_TOKEN_KEY, token);
    }
    delToken() {
        sessionStorage.removeItem(StorageVariable.ACCESS_TOKEN_KEY);
    }
    getToken() {
        return sessionStorage.getItem(StorageVariable.ACCESS_TOKEN_KEY);
    }

    // token_refresh
    setTokenRefresh(token: string) {
        sessionStorage.setItem(StorageVariable.REFRESH_TOKEN_KEY, token);
    }
    delTokenRefresh() {
        sessionStorage.removeItem(StorageVariable.REFRESH_TOKEN_KEY);
    }
    getTokenRefresh() {
        return sessionStorage.getItem(StorageVariable.REFRESH_TOKEN_KEY);
    }

    //rut_usuario
    setRutUsuario(usu: string) {
        localStorage.setItem(StorageVariable.RUT_USUARIO, usu);
    }   
    delRutUsuario() {
        localStorage.removeItem(StorageVariable.RUT_USUARIO);
    }
    getRutUsuario(): any {
        return localStorage.getItem(StorageVariable.RUT_USUARIO);
    }

    //rut_empresa
    setRutEmpresa(emp: string) {
        localStorage.setItem(StorageVariable.RUT_EMPRESA, emp);
    }
    delRutEmpresa() {
        localStorage.removeItem(StorageVariable.RUT_EMPRESA);
    }
    getRutEmpresa(): any {
        return localStorage.getItem(StorageVariable.RUT_EMPRESA);
    }

    //sucursal_codigo
    setSucursalCodigo(suc: string) {
        localStorage.setItem(StorageVariable.SUCURSAL_CODIGO, suc);
    }
    delSucursalCodigo() {
        localStorage.removeItem(StorageVariable.SUCURSAL_CODIGO);
    }
    getSucursalCodigo(): any {
        return localStorage.getItem(StorageVariable.SUCURSAL_CODIGO);
    }

    //latitud
    setLatitudEmpresa(lat: string) {
        localStorage.setItem(StorageVariable.LATITUD, lat);
    }
    delLatitudEmpresa() {
        localStorage.removeItem(StorageVariable.LATITUD);
    }
    getLatitudEmpresa(): any {
        return localStorage.getItem(StorageVariable.LATITUD);
    }

    //longitud
    setlongitudEmpresa(lon: string) {
        localStorage.setItem(StorageVariable.LONGITUD, lon);
    }
    delLongitudEmpresa() {
        localStorage.removeItem(StorageVariable.LONGITUD);
    }
    getLongitudEmpresa(): any {
        return localStorage.getItem(StorageVariable.LONGITUD);
    }

    // //codigo_vendedor
    // setCodigoVendedor(codvendedor:string)
    // {
    //     localStorage.setItem('codigo_vendedor', codvendedor);
    // }
    // delCodigoVendedor()
    // {
    //     localStorage.removeItem('codigo_vendedor');
    // }
    // getCodigoVendedor():any
    // {
    //     return localStorage.getItem('codigo_vendedor');
    // }




    // //rut_vendedor
    // setrutVendedor(rut_vendedor:string)
    // {
    //     localStorage.setItem('rut_vendedor', rut_vendedor);
    // }
    // delrutVendedor()
    // {
    //     localStorage.removeItem('rut_vendedor');
    // }
    // getrutVendedor():any
    // {
    //     return localStorage.getItem('rut_vendedor');
    // }

}
